// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_2uqI6","spinnerBorder":"RHSVo","primary":"ARQcp","loading":"xvnZA","loaderWrapper":"_3JGu3","wait":"_17lDT","detail":"_2sYYs","alignment":"_29nXJ"};